export default __webpack_public_path__ + "static/media/session-record.fab95211.svg";